import $ from 'jquery';
import bodyScroll from '../scripts/bodyScroll';

$.addInit(function(context){
	var base = '.i-showContentRoom';
	$(base, context).each(function(){
		var component = $(this);
		var contentRoom = $('body').find('.b-contentRoom');
		var close = contentRoom.find('.b-contentRoom-close');

		component.on('click',  function(e) {
			e.preventDefault();
			contentRoom.addClass('m-active');
			bodyScroll.disable(contentRoom.get(0), {reserveScrollBarGap: true});
		});

		close.on('click', function() {
			contentRoom.removeClass('m-active');
			bodyScroll.enable(contentRoom.get(0));
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/i-showContentRoom.js
// module id = 23
// module chunks = 0